import classNames                              from 'classnames'
import React                                   from 'react'
import { Alert, Panel, Form, Radio, Button,
         FormGroup, ButtonToolbar, Glyphicon } from 'react-bootstrap'

import LoggedOutDailyMenu from './logged_out_daily_menu'

import { GLOBAL, PER_GROUP } from 'alto-react-canteen/lib/settings'

export default class DailyMenu extends LoggedOutDailyMenu
  _additionalGroupPanelHeading: (groupMenu) ->
    <span className='dot'>&bull;</span> unless groupMenu.isSaved()

  groupMenu: (groupMenu) ->
    otherOrdersExist      = groupMenu.selectionForOtherCanteensExists()
    afterDeadline         = groupMenu.isAfterDeadline()
    selectedMeals         = groupMenu.selectedMeals()
    { confirmationStyle } = @props

    <div>
      {<Alert>Objednávky tohoto chodu již nelze měnit.      </Alert> if afterDeadline}
      {<Alert>Na tento chod máte již vybráno v jiné jídelně.</Alert> if otherOrdersExist}

      <div className={'flex-column-container flex-space-between' if confirmationStyle == PER_GROUP}>
        <div>
          {groupMenu.courseMenus().map (courseMenu) =>
             @courseMenu(courseMenu, groupMenu, selectedMeals)}
        </div>

        {@buttons(groupMenu) if confirmationStyle == PER_GROUP}
      </div>
    </div>

  courseMenu: (courseMenu, groupMenu, selectedMeals) ->
    course = courseMenu.course
    locked = groupMenu.isLocked()

    if course.isAdditional
      selectedMainMeal = selectedMeals.find (meal) -> meal.additionalCourseName == course.name
      mustSelect       = selectedMainMeal and not courseMenu.selectedMealNumber
      locked           = locked or not selectedMainMeal

    <Form key={course.name} className='course-menu'>
      {<h4>{course.displayName}</h4> if groupMenu.hasMoreThanOneCourse()}
      {if mustSelect then <Alert bsStyle='warning'>Vyberte přílohu</Alert>}

      <FormGroup>{@radios(course, courseMenu, groupMenu, locked)}</FormGroup>
    </Form>

  radios: (course, courseMenu, groupMenu, locked) ->
    radios = courseMenu.meals.map (meal) =>
      locked = true if meal.hasAdditional() and not groupMenu.additionalMealsExistFor(meal)

      <Radio key={meal.number} disabled={locked}
             checked={courseMenu.selectedMealNumber == meal.number}
             onChange={=> @props.selectMeal(meal)}>
        {meal.name}
      </Radio>

    if @props.confirmationStyle == GLOBAL
      noSelection =
        <Radio key={100} disabled={locked}
               checked={not courseMenu.selectedMealNumber}
               onChange={=> @props.deselectMeal(courseMenu.canteen.id, courseMenu.date, courseMenu.course)}>
          Žádný výběr
        </Radio>

      radios = radios.unshift(noSelection)

    radios

  buttons: (groupMenu) ->
    saved        = groupMenu.isSaved()
    hasSelection = groupMenu.hasSelection()

    <ButtonToolbar>
      <Button id={groupMenu.group.name + '-submit'}
              className={classNames('menu-button', 'menu-submit', inactive: not hasSelection)}
              bsStyle={if saved then 'success' else 'primary'}
              onClick={=> @props.saveCourseGroup(groupMenu.group)}
              disabled={groupMenu.isLocked() or saved or not groupMenu.allAdditionalMealsSelected()}>
        {if saved then 'Uloženo' else 'Uložit'}
      </Button>

      <Button id={groupMenu.group.name + '-cancel'}
              className={classNames('menu-button', 'menu-cancel', inactive: not hasSelection)}
              bsStyle='danger'
              onClick={=> @props.cancelCourseGroup(groupMenu.group)}
              disabled={groupMenu.isLocked() or not hasSelection}>
        Zrušit
      </Button>
    </ButtonToolbar>

  _hasAlert: (groupMenu) -> groupMenu.isLocked()
  _showDiscriminator: -> @props.confirmationStyle != PER_GROUP
